import { render, staticRenderFns } from "./FileDrop.vue?vue&type=template&id=38fb5d5c&scoped=true&"
import script from "./FileDrop.vue?vue&type=script&lang=js&"
export * from "./FileDrop.vue?vue&type=script&lang=js&"
import style0 from "./FileDrop.vue?vue&type=style&index=0&id=38fb5d5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fb5d5c",
  null
  
)

export default component.exports